export default {
  install(Vue) {
    Vue.prototype.get_foreign_language = async function () {
      const api = `${window.endpoints.api}/BasicInformation/ForeignLanguage`;
      const params = { IsEnable: true };

      const response = await this.$http.get(api, { params });
      const sorted = response.data.sort((a, b) => a.Seq - b.Seq);

      return sorted.map(({ Code, Guid, Name }) => ({
        Code,
        Guid,
        Name
      }));
    };
  },
};
